export default "__VITE_ASSET__$m2VUWtz__"